<!--
 * @Author: your name
 * @Date: 2021-06-22 15:05:00
 * @LastEditTime: 2024-02-27 10:49:05
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolImage.vue
-->
<!--图片-->

<template>
  <div class="tool-image">
    <img class="field-media" :class="{'scale-type':!media.ext_val_scaleType}" :src="media.field_item_path" alt />
  </div>
</template>

<script>
export default {
  name: "ToolImage",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-image {
  width: 100%;
  height: 100%;
  // background: #000;
  .field-media {
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: contain;
    position: absolute;
    top: 0;
  }
  .scale-type {
    object-fit: fill;
  }
}
</style>
